var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitionCarouselRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26007 2.57257C7.56517 2.26748 8.05983 2.26748 8.36493 2.57257L17.7399 11.9476C18.045 12.2527 18.045 12.7473 17.7399 13.0524L8.36493 22.4274C8.05983 22.7325 7.56517 22.7325 7.26007 22.4274C6.95498 22.1223 6.95498 21.6277 7.26007 21.3226L16.0826 12.5L7.26007 3.67743C6.95498 3.37233 6.95498 2.87767 7.26007 2.57257Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitionCarouselRight);
export default __webpack_public_path__ + "static/media/CompetitionCarouselRight.e5edf1a982bc6413802761da37123105.svg";
export { ForwardRef as ReactComponent };